import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import {
  OpenInfoForms,
  fetchOpenInfoRecord,
  fetchOpenInfoUpdate,
  IOpenInfo,
} from '../../../../features/open-info';
import { useEntityUpdate } from '../../../../features/entities/hooks';
import { PreloaderWrapper } from '../../../../components/preloader-wrapper';
import { PageTitle } from '../../../../components/page-title';
import { CabinetContainer } from '../../../../components/cabinet-container';
import { ROUTE_OPEN_INFO } from '../../../../common/constants';
import { get } from '../../../../common/utils';

export const OpenInfoUpdatePage: FC = () => {
  const { t } = useTranslation();
  const { isFetching, isUpdating, data, handleValid } = useEntityUpdate<IOpenInfo>({
    entity: 'openInfo',
    recordThunk: fetchOpenInfoRecord,
    updateThunk: fetchOpenInfoUpdate,
    nextPath: ROUTE_OPEN_INFO,
  });

  const defaultValues = { ...data };

  return (
    <>
      <Helmet>
        <title>{t('open.info.update')}</title>
      </Helmet>
      <CabinetContainer>
        <PageTitle title={t('open.info.update.title')} mb={3} />
        <PreloaderWrapper isLoading={isFetching}>
          <OpenInfoForms
            onValid={handleValid}
            defaultValues={defaultValues}
            isLoading={isUpdating}
            key={get(data, 'id')}
          />
        </PreloaderWrapper>
      </CabinetContainer>
    </>
  );
};
